<template>
    <div class="spinner-container"
         :style="`background-color: ${background}; ${fixed ? 'position: fixed !important;' : ''}`">
        <svg class="circular">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
        </svg>
        <p v-if="message !== ''" class="spinner-message">{{ message }}</p>
    </div>
</template>

<script>
  export default {
    name: 'Spinner',

    props: {
      background: {default: 'rgba(255, 255, 255, 0.5)', type: String},
      message   : {default: '', type: String},
      fixed     : {default: false, type: Boolean},
    },
  }
</script>
